<!--
 * @Description: 修改教学设计
 * @Author: PF
 * @Date: 2024-01-04 14:50:25
 * @LastEditors: PF
 * @LastEditTime: 2024-07-26 16:16:59
-->
<template>
  <div>
    <el-dialog class="w850 hp80" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改教学设计</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期">
              <span>{{ruleForm.xqmc}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程">
              {{ruleForm.kcmc}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="周次">
              <span>第{{ruleForm.zc}}周</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="班级/节次">
              <span>{{ruleForm.bjmc}}/星期{{ruleForm.xingqi}} 第{{ruleForm.jc}}节</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学单元">
              <el-select class="mr10" v-model="ruleForm.jxdyid" @change="danDuanChange" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueDanYuan=true;row={kcid:kcid,kcmc:kcmc}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学内容">
              <el-select class="mr10" v-model="ruleForm.jxnrid" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueNeiRong=true;row={kcid:kcid,kcmc:kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-for="(item, index) in ruleForm.jxsjmb" :key="index">
            <el-form-item :label="item.mbzdmc" :prop="'jxsjmb.' + index + '.nr'" :rules="item.sfbt ? [{required: true,message:  '必填项',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <el-input v-if="item.zdlx===1" v-model="item.nr" type="textarea" :rows="1" />
              <div v-if="item.zdlx===2">
                <ueditor v-model:value="item.nr" :row="{height:350}" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span>
          <el-button type="primary" @click="submitForm(0)">保存 </el-button>
          <el-button type="primary" @click="submitForm(1)">保存并提交</el-button>
          <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="row" @ReturnData="keChengChange" />
  <jiaoxueneirong v-if="openAddJiaoXueNeiRong" v-model:openAdd="openAddJiaoXueNeiRong" :row="row" @ReturnData="danDuanChange" />
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import { closeWindow, loadSelect, actionPost, actionPatch } from '@/api/common.js'
import jiaoxuedanyuan from '@/components/jiaoxuedanyuan.vue'
import jiaoxueneirong from '@/components/jiaoxueneirong.vue'
import ueditor from '@/components/ueditor.vue'

const emits = defineEmits(['update:openEdit', 'ReturnData'])
const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false },
  chechboxtrue: { type: Array, required: false }
})

const ruleFormRef = ref(null)
const ruleForm = ref({})

const row = ref()

// 查询教学单元
const jxdyData = ref([])
const bjlist = ref([])
const keChengChange = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    data: jxdyData,
    parms: { kcid: ruleForm.value.kcid, order: 'sx', sort: 'asc' }
  })
}
// 查询教学内容
const jxnrData = ref([])
const danDuanChange = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    data: jxnrData,
    parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
  })
}

const openAddJiaoXueDanYuan = ref(false) // 添加教学单元
const openAddJiaoXueNeiRong = ref(false) // 添加教学内容

const week = ref(['', '一', '二', '三', '四', '五', '六', '日'])
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      // 获取详情
      actionPost({
        url: '/api/v2/jiaowu/jiaowujiaoxuesheji/' + props.row.jxsjid,
        data: {}
      }).then((res) => {
        if (res.code === 200) {
          ruleForm.value = res.data
          keChengChange()
          danDuanChange()
          ruleForm.value.kcid = res.data.kcid
          ruleForm.value.jxnrid = res.data.jxnrid
          ruleForm.value.xingqi = week.value[res.data.xq]
          ruleForm.value.jxsjmb = []
          ruleForm.value.zt = ruleForm.value.zt ? ruleForm.value.zt.value : ''
          if (ruleForm.value.zt === 0) {
            ruleForm.value.jxsjmb = ruleForm.value.jxsjnrs ? ruleForm.value.jxsjnrs.map(item => { item.zdlx = item.zdlx ? item.zdlx.value : ''; return item }) : []
          } else if (ruleForm.value.zt === 1) {
            ruleForm.value.jxsjmb = ruleForm.value.listMuBanNeiRong ? ruleForm.value.listMuBanNeiRong.map(item => { item.zdlx = item.zdlx ? item.zdlx.value : ''; return item }) : []
          }
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 保存
const submitForm = async (val) => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const data = {
    id: ruleForm.value.id,
    kbid: props.row.id,
    xqid: ruleForm.value.xqid,
    jxdyid: ruleForm.value.jxdyid,
    jxnrid: ruleForm.value.jxnrid,
    zc: ruleForm.value.zc,
    bjid: ruleForm.value.bjid,
    jc: ruleForm.value.jc,
    kcid: ruleForm.value.kcid,
    xq: ruleForm.value.xq,
    jxsjnrs: ruleForm.value.jxsjmb,
    zt: val
  }
  const o = { url: '/api/v2/jiaowu/jiaowujiaoxuesheji', data: data }
  actionPatch(o).then((res) => {
    if (res.code === 200) {
      closeWindow('openEdit', emits, true)
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}

</script>
<style lang="less" scoped>
.banjibox {
  width: 300px;
  display: flex;
  flex-direction: column;
}
.fwb {
  width: 400px;
}
</style>
